import React from "react";

interface TableRowHeaderProps
  extends React.HTMLAttributes<HTMLTableRowElement> {
  children: React.ReactNode;
  className?: string;
  borderTop?: boolean;
}

export const TableRowHeader = ({
  children,
  className,
  borderTop = true,
  ...rest
}: TableRowHeaderProps) => {
  return (
    <tr className={`${borderTop ? "border-top" : ""} ${className}`} {...rest}>
      {children}
    </tr>
  );
};
